import type { ButtonHTMLAttributes, PropsWithChildren, ReactNode } from 'react';

export function Badge({ children, tone = 'neutral' }: PropsWithChildren<{ tone?: 'neutral' | 'positive' | 'warning' }>) {
  return <span className={`badge badge--${tone}`}>{children}</span>;
}

export function IconButton({ label, children, ...props }: ButtonHTMLAttributes<HTMLButtonElement> & { label: string; children: ReactNode }) {
  return (
    <button type="button" aria-label={label} title={label} {...props}>
      {children}
    </button>
  );
}

